<script lang="ts" context="module">

    const paramCache = new Map<string, Promise<string>>();

</script>


<script lang="ts">
import { paramsService } from "../services";

    export let id : string;

    let name: string = '';

    $: getName(id)

    async function getName(id:string){

        if (!paramCache.has(id)) {
            paramCache.set(id, paramsService.findOne(id).then(param => param.name))
        }

       name = await paramCache.get(id);
    }


</script>

{name}

